import React from "react";
import styled from "styled-components";
import { v4 as uuidv4 } from "uuid";
import { useTranslation } from "react-i18next";

//
import PageTop from "../../sections/PageTop";
import ReviewList from "./sections/ReviewList";
import AboutClinicForm from "../aboutClinic/sections/AboutClinicForm";
import Location from "../../sections/Location";

const linkChain = [
  {
    id: uuidv4(),
    title: "navHome",
    to: "/",
  },
  {
    id: uuidv4(),
    title: "footerAboutReview",
  },
];

export default function Review() {
  const { t } = useTranslation();

  return (
    <StyledReview>
      <PageTop title={t("reviewTitle")} linkList={linkChain} />
      <ReviewList />
      <AboutClinicForm />
      <Location />
    </StyledReview>
  );
}

const StyledReview = styled.main``;
